import React from 'react';
import ReactDOM from 'react-dom';

const Option = (props) => (
    props.post.map(post2 =>
        <option key={post2.id} value={post2.id}>{post2.name}</option>
    )
);

export default Option;


// WEBPACK FOOTER //
// ./src/components/Option.js